const APIPort = process.env.APIPort;
const online = process.env.NODE_ENV == 'development' ? false : true;
const ishttps = 'https:' == document.location.protocol ? true: false;
let domainName = ishttps ?'https':'http'
let apiUrl = APIPort===8006?`/`:`${domainName}://gateway.ofd.cn`;// suwell.devgateway.wps.cn    gateway.ofd.cn
if (!online) {
  // apiUrl = APIPort===8006?'http://172.16.14.73:8096':`${domainName}://172.16.14.188:${APIPort}`;
  apiUrl = APIPort===8006?'http://172.16.14.73:8096':`${domainName}://172.16.14.72:8096`;
};
// 71环境
// http://172.16.14.71:30905/   接口：http://172.16.14.71:30801/
const common = {
    localLoginUrl: online ? 'http://172.16.14.188:9004/login/#/login' : 'http://172.16.32.22:8093',
    apiDocConversionUrl: online ? 'http://172.16.14.188:9004/' : 'http://172.16.32.22:8091',
    apiDocudomentUrl: online ? 'http://172.16.14.188:9004/document/#/index' : 'http://172.16.32.39:8092/#/index',
    localManageUrl: online ? 'http://172.16.14.188:8888/' : 'http://172.16.32.22:8888',
    baseShareUrl: online ? 'http://172.16.14.188:9004/#/' : 'http://192.168.2.53:8092/',
    readCodeUrl: online ? `${domainName}://www.ofd.cn` : 'http://172.16.33.86:8091', //suwell.devweb.wps.cn     www.ofd.cn
    baseurl: online ? `${domainName}://reader.ofd.cn/experience-web-reader/reader` : `${domainName}://reader.ofd.cn/experience-web-reader/reader`,//suwell.devreader.wps.cn    reader.ofd.cn
    apiUrl,
    staticPIC: `${apiUrl}/pubelec/api/template_compose/download_template/v1?fileId=`
};

export default common



// WEBPACK FOOTER //
// ./src/comm/utils/common.js